import { LocalDate } from 'js-joda';

import { dashboard } from 'types';
import AppConstants from 'constants/AppConstants';
import protos from 'utils/protos';

const { BusinessDayNote } = protos;

export function fetch(date: LocalDate): ApiAction {
  return {
    TockApi: {
      getProto: `/business/day/note?date=${date.toString()}`,
      type: AppConstants.DAY_NOTES_FETCH,
      onError: {
        1001: '',
        defaultToOriginal: true,
      },
    },
  };
}

export function fetchReservation(date: LocalDate): ApiAction {
  return {
    TockApi: {
      getProto: `/business/day/note?date=${date.toString()}`,
      type: AppConstants.DAY_NOTES_RESERVATION,
      onError: {
        1001: '',
        defaultToOriginal: true,
      },
    },
  };
}

export function save(note: dashboard.IBusinessDayNote): ApiAction {
  const update = BusinessDayNote.fromObject(note);
  return {
    TockApi: {
      postProto: '/business/day/note',
      type: AppConstants.DAY_NOTES_SAVE,
      request: update,
    },
  };
}

export function dayNotesUpdate(changeUpdate: dashboard.CalendarDayEntityUpdates): BaseTockAction {
  return {
    type: AppConstants.DAY_NOTES_ENTITY_UPDATE,
    payload: changeUpdate,
  };
}
